import { render, staticRenderFns } from "./ReplyByTemplate.vue?vue&type=template&id=2039edfb&scoped=true&"
import script from "./ReplyByTemplate.vue?vue&type=script&lang=js&"
export * from "./ReplyByTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ReplyByTemplate.vue?vue&type=style&index=0&id=2039edfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039edfb",
  null
  
)

export default component.exports